// extracted by mini-css-extract-plugin
module.exports = {"about":"styles_about__t1Xk3","content":"styles_content__3M2jz","logo":"styles_logo__3qjQN"};